var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOmr = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7338_16074)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24.2673C18.6274 24.2673 24 18.8948 24 12.2673C24 5.63992 18.6274 0.267334 12 0.267334C5.37258 0.267334 0 5.63992 0 12.2673C0 18.8948 5.37258 24.2673 12 24.2673Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 12.2692C0 16.8177 2.53078 20.7749 6.26086 22.8101V1.72827C2.53078 3.76349 0 7.72068 0 12.2692Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2537 16.4432C23.736 15.1433 24 13.7372 24 12.2693C24 10.8015 23.736 9.3954 23.2537 8.09546H0.746438C0.264047 9.3954 0 10.8015 0 12.2693C0 13.7372 0.264047 15.1433 0.746438 16.4432L12 17.4867L23.2537 16.4432Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9997 24.2653C17.1593 24.2653 21.5577 21.0088 23.2533 16.4392H0.746094C2.44156 21.0088 6.84012 24.2653 11.9997 24.2653Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 12.268C0 17.8123 3.76036 22.4776 8.86955 23.8546V0.681396C3.76036 2.0584 0 6.72368 0 12.268Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.34159 5.54988L6.23483 4.44312L5.49701 5.18102L4.7592 4.44312L3.65244 5.54988L4.3903 6.28774L3.65234 7.02565L4.75911 8.13241L5.49697 7.39451L6.23483 8.13241L7.34159 7.02565L6.60373 6.28774L7.34159 5.54988Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7338_16074"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.267334)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgOmr);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/OMR.2dbb4eb26cc21526f452e340376b1c07.svg";